import { useEffect, useState } from "react";
import { useApp } from "../../context/App";
import FlatList from "flatlist-react";
import { api, urls } from "../../services/api";
import { ICategorieNews, INews } from "../../types/news";
import { TitlePage } from "../../components/ui/TitlePage";
import { ItemCategory } from "../../components/ui/ItemCategory";
import brasao from "../../assets/imgs/brasao.webp";
import { FilterIcon } from "../../components/ui/icons/common/filter";
import { Fechar } from "../../components/ui/icons/common/fechar";

export function ListNewsScreen() {
  const [news, setNews] = useState<INews[]>([]);
  const [categories, setCategories] = useState<ICategorieNews[]>([]);
  const [layoutGrid, setLayoutGrid] = useState<boolean>(false);
  const [idCategorie, setIdCategorie] = useState<number>(99);
  const { mobile, configDomainURL } = useApp();
  const domain = configDomainURL;
  const [pag_atual, setPagAtual] = useState<number>(1);
  const [filter, setFilter] = useState<boolean>(false);
  const [ocultarBotao, setOcultarBotao] = useState<boolean>(false);
  const [pegarTermoID, setPegarTermoID] = useState<number>(0);
  const [pegarTermo, setPegarTermo] = useState<string>("categoria");
  const [loading, setLoading] = useState<string>("Carregando...");

  function slugify(text: string) {
    return text
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  }

  function parseDate(date: string) {
    const dateSplit = date.split("/");
    const monthsOfYear = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];
    const year = dateSplit[2].split(" -")[0];
    const month = monthsOfYear[parseInt(dateSplit[1]) - 1];
    const dateParsed = `${dateSplit[0]} ${month} ${year}`;
    return dateParsed;
  }

  const handleGetNewsByCategorie = async (id: number, title?: string) => {
    try {
      const url = new URL(window.location.href);
      if (id === 99) {
        url.searchParams.delete("categoria");
      } else if (title) {
        url.searchParams.set("categoria", slugify(title));
      }
      window.history.pushState({}, "", url.toString());

      if (id === 99) {
        const response = await api.get(urls.ListNews);
        setNews(response.data.noticias);
        setIdCategorie(id);
        setOcultarBotao(false);
        return;
      }

      setOcultarBotao(true);
      const response = await api.get(urls.NewsByCategorie + id);
      setNews(response.data.noticias);
      setIdCategorie(id);
      setPegarTermoID(id);
      getNomeCategoria(id);
      if (response.data.noticias.length < 1) {
        setLoading("Sem notícias relacionadas.");
      }
    } catch (error) {
      // error silent
    }
  };

  const getPaginacao = async (id: number) => {
    try {
      var response = await api.get(urls.NewsByPage + id);
      for (let i = 0; i < response.data.noticias.length; i++) {
        setNews((news) => [...news, response.data.noticias[i]]);
      }
      setPagAtual(id);
    } catch (error) {
      // error silent
    }
  };

  const getPaginacaoCat = async (pagina: number) => {
    try {
      for (let i = 0; i < categories.length; i++) {
        if (categories[i].newsCategoryId === pegarTermoID) {
          const response = await api.get(
            urls.NewsByCategorie + pegarTermoID + "/pagina/" + pagina
          );
          for (let i = 0; i < response.data.noticias.length; i++) {
            setNews((news) => [...news, response.data.noticias[i]]);
          }
          setPagAtual(pagina);
        }
      }
    } catch (error) {
      // error silent
    }
  };

  const ListNewsScreen_img_caminho =
    "https://api-portal.itajai.sc.gov.br/public/portaladm-pmitajai/noticias/foto/";

  const getNomeCategoria = async (id: number) => {
    try {
      const response = await api.get<ICategorieNews[]>(urls.ListCategories);
      for (let i = 0; i < response.data.length; i++) {
        if (response.data[i].newsCategoryId === id) {
          setPegarTermo(response.data[i].title);
        }
      }
    } catch (error) {
      // error silent
    }
  };

  useEffect(() => {
    (async () => {
      try {
        let resCatsData: ICategorieNews[] = [];
        try {
          const resCats = await api.get<ICategorieNews[]>(urls.ListCategories);
          resCatsData = resCats.data;
          setCategories(resCatsData);
        } catch (catError) {
          console.warn("Could not fetch categories, continuing with ID filter only:", catError);
          setCategories([]);
        }

        const response = await api.get(urls.ListNews);
        var parametros_da_url = window.location.search;
        var parametros = new URLSearchParams(parametros_da_url);
        const catSlug = parametros.get("categoria");

        if (catSlug && resCatsData.length > 0) {
          const categoryFound = resCatsData.find(
            (c) => slugify(c.title) === catSlug
          );
          if (categoryFound) {
            handleGetNewsByCategorie(
              categoryFound.newsCategoryId,
              categoryFound.title
            );
          } else {
            setNews(response.data.noticias);
          }
        } else {
          setNews(response.data.noticias);
        }
      } catch (error) {
        // error silent
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  useEffect(() => {
    setFilter(filter);
  }, [filter]);

  return (
    <div className="flex flex-col w-full min-h-screen bg-white dark:bg-surface-dark transition-colors items-center justify-start">
      <div className="w-full flex flex-col items-center">
        {mobile && <div className="h-20" />}

        <div className="flex w-11/12 lg:w-3/5 items-center justify-between lg:justify-center mt-6">
          <div className="w-full lg:w-auto">
            <TitlePage
              title="NOTÍCIAS"
              iconNews
              onChange={(value) => {
                setLayoutGrid(value);
              }}
            />
          </div>
          <button
            className="lg:hidden p-3 bg-gray-100 dark:bg-surface-dark-alt rounded-lg flex items-center justify-center border-none cursor-pointer"
            onClick={() => setFilter(!filter)}
          >
            <FilterIcon className="fill-gray-600 dark:fill-gray-300 h-6 w-6" />
          </button>
        </div>

        {/* Overlay do filtro no mobile */}
        {filter && (
          <div
            className="lg:hidden fixed inset-0 z-40 bg-black/60 backdrop-blur-sm"
            onClick={() => setFilter(false)}
          />
        )}

        <div className="flex flex-col lg:flex-row w-11/12 lg:w-3/5 mt-6 lg:mt-8 mb-16 gap-6 lg:gap-8">
          <div
            className={`fixed lg:relative inset-y-0 left-0 z-50 lg:z-auto w-4/5 sm:w-80 lg:w-1/4 bg-white dark:bg-surface-dark-alt lg:bg-transparent lg:dark:bg-transparent p-6 lg:p-0 shadow-2xl lg:shadow-none flex flex-col gap-2 overflow-y-auto transition-transform duration-300 ease-in-out ${filter ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
              }`}
          >
            <div className="mb-6 lg:hidden flex justify-between items-center">
              <span className="font-bold text-gray-900 dark:text-gray-100 text-lg">Filtros</span>
              <button
                onClick={() => setFilter(false)}
                className="p-2 border-none bg-transparent"
              >
                <Fechar className="h-6 w-6 fill-gray-500 dark:fill-gray-400" />
              </button>
            </div>
            <ItemCategory
              title="Geral"
              isActive={idCategorie === 99}
              onClick={() => handleGetNewsByCategorie(99)}
            />
            <FlatList
              list={categories}
              renderItem={(item) => (
                <ItemCategory
                  key={item.newsCategoryId}
                  title={item.title}
                  isActive={idCategorie === item.newsCategoryId}
                  onClick={() =>
                    handleGetNewsByCategorie(item.newsCategoryId, item.title)
                  }
                />
              )}
            />
          </div>

          {news.length < 1 ? (
            <div className="flex-1 flex justify-center py-20 text-gray-500 dark:text-gray-400">{loading}</div>
          ) : layoutGrid ? (
            <div className="flex-1 w-full lg:w-3/4">
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 w-full">
                <FlatList
                  list={news}
                  renderItem={(item) => (
                    <a
                      key={item.newsId}
                      href={`${domain}noticias/${item.newsId}/${item.title
                        .toLowerCase()
                        .replaceAll(" ", "-")
                        .replaceAll("/", "-")
                        .replaceAll(/[&\\#,+()$~%.'":*?<>{}]/g, "")
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f]/g, "")}`}
                      className="no-underline group flex flex-col"
                    >
                      <div className="relative w-full aspect-[4/3] rounded-2xl lg:rounded-xl overflow-hidden shadow-sm group-hover:shadow-md dark:shadow-none dark:border dark:border-border-dark mb-4 transition-all group-hover:-translate-y-1">
                        {item.img ? (
                          <img src={ListNewsScreen_img_caminho + item.img} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                        ) : (
                          <div
                            className="w-full h-full bg-azul_itajai02 dark:bg-gray-800 bg-no-repeat bg-center bg-[length:auto_40%] lg:bg-[length:auto_40%] transition-transform duration-500 group-hover:scale-105"
                            style={{ backgroundImage: "url( " + brasao + " )" }}
                          ></div>
                        )}
                      </div>
                      <div className="flex flex-col flex-1">
                        <h3 className="font-roboto font-bold text-gray-900 dark:text-gray-100 text-lg lg:text-sm leading-snug lg:leading-normal mb-2 lg:mb-3 line-clamp-3 group-hover:text-primary dark:group-hover:text-primary-light transition-colors">
                          {item.title}
                        </h3>
                        <span className="mt-auto font-roboto font-normal text-gray-500 dark:text-gray-400 text-sm lg:text-xs">
                          {parseDate(item.published)}
                        </span>
                      </div>
                    </a>
                  )}
                />
              </div>
            </div>
          ) : (
            <div className="flex-1 flex flex-col w-full lg:w-3/4 gap-6">
              <FlatList
                list={news}
                renderItem={(item) => (
                  <a
                    key={item.newsId}
                    href={`${domain}noticias/${item.newsId}/${item.title
                      .toLowerCase()
                      .replaceAll(" ", "-")
                      .replaceAll("/", "-")
                      .replaceAll(/[&\\#,+()$~%.'":*?<>{}]/g, "")
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")}`}
                    className="w-full flex flex-col md:flex-row gap-4 lg:gap-6 group no-underline pb-6 border-b border-gray-200 dark:border-gray-800 last:border-0"
                  >
                    <div className="relative w-full md:w-2/5 aspect-[16/9] lg:aspect-[4/3] shrink-0 rounded-2xl lg:rounded-xl overflow-hidden shadow-sm group-hover:shadow-md dark:shadow-none dark:border dark:border-border-dark transition-all">
                      {item.img ? (
                        <img src={ListNewsScreen_img_caminho + item.img} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                      ) : (
                        <div
                          className="w-full h-full bg-azul_itajai02 dark:bg-gray-800 bg-no-repeat bg-center bg-[length:auto_40%] xl:bg-[length:auto_35%] transition-transform duration-500 group-hover:scale-105"
                          style={{ backgroundImage: "url( " + brasao + " )" }}
                        ></div>
                      )}
                    </div>
                    <div className="flex flex-col flex-1 py-1 lg:py-2">
                      <h3 className="font-roboto font-bold text-gray-900 dark:text-gray-100 text-lg lg:text-xl leading-snug mb-3 lg:mb-3 line-clamp-2 group-hover:text-primary dark:group-hover:text-primary-light transition-colors">
                        {item.title}
                      </h3>
                      <p className="font-roboto font-normal text-gray-600 dark:text-gray-300 text-base lg:text-sm leading-relaxed mb-4 lg:mb-4 line-clamp-3">
                        {item.description}
                      </p>
                      <span className="mt-auto font-roboto font-medium text-gray-500 dark:text-gray-400 text-sm lg:text-xs">
                        {parseDate(item.published)}
                      </span>
                    </div>
                  </a>
                )}
              />
            </div>
          )}
        </div>

        {!ocultarBotao ? (
          <div className="w-full flex justify-center my-8 lg:my-12">
            <button
              className="bg-white dark:bg-surface-dark-alt border border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-200 px-6 py-3 rounded-xl lg:rounded-lg text-base lg:text-sm font-medium hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors shadow-sm cursor-pointer"
              id="sentinela"
              onClick={() => getPaginacao(pag_atual + 1)}
            >
              Carregar mais notícias
            </button>
          </div>
        ) : (
          <div className="w-full flex justify-center my-8 lg:my-12">
            <button
              className="bg-white dark:bg-surface-dark-alt border border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-200 px-6 py-3 rounded-xl lg:rounded-lg text-base lg:text-sm font-medium hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors shadow-sm cursor-pointer"
              id="sentinela"
              onClick={() => getPaginacaoCat(pag_atual + 1)}
            >
              Carregar mais notícias sobre {pegarTermo}
            </button>
          </div>
        )}

      </div>
    </div>
  );
}

